import styled from 'styled-components';
import { PopoverInternal } from './components/PopoverInternal.js';

const AnimatedPopoverInternal = styled(PopoverInternal)`
  position: relative;

  @keyframes enterFromTop {
    0% {
      opacity: 0;
      top: -15px;
    }
    100% {
      opacity: 1;
      top: 0;
    }
  }
  @keyframes enterFromRight {
    0% {
      opacity: 0;
      left: 15px;
    }
    100% {
      opacity: 1;
      left: 0;
    }
  }
  @keyframes enterFromBottom {
    0% {
      opacity: 0;
      top: 15px;
    }
    100% {
      opacity: 1;
      top: 0;
    }
  }
  @keyframes enterFromLeft {
    0% {
      opacity: 0;
      left: -15px;
    }
    100% {
      opacity: 1;
      left: 0;
    }
  }

  @keyframes disableMouse {
    0%,
    99% {
      pointer-events: none;
    }
    100% {
      pointer-events: auto;
    }
  }
`;

export { AnimatedPopoverInternal };
